import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Renderiza o alerta "sua avaliacao foi publicada". O subject e o proprio
 * destinatario (User); content() traz store_name + username do dono da loja
 * para montar o link /u/{username}/seller.
 */
export default class SellerReviewApprovedNotification extends Notification {
  icon() {
    return 'fas fa-star';
  }
  href() {
    const username = this.attrs.notification.content()?.username;
    if (!username) return '#';
    return app.route('marketplace.user_seller', {
      username
    });
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.seller_review_approved', {
      store: data.store_name
    });
  }
  excerpt() {
    return this.attrs.notification.content()?.store_name ?? '';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/SellerReviewApprovedNotification', SellerReviewApprovedNotification);